import { RootMutationType } from '../interfaces';

export const MutationTypes: RootMutationType = {
    setToken: 'setToken',
    setTokenTimestamp: 'setTokenTimestamp',
    setIsIdentified: 'setIsIdentified',
    setScreeningUnit: 'setScreeningUnit',
    setDataLoading: 'setDataLoading',
    setIsLanguagesLoaded: 'setIsLanguagesLoaded',
    setIsAppLoaded: 'setIsAppLoaded',
    setShowErrInfoModal: 'setShowErrInfoModal',
    setPopUpErrMessage: 'setPopUpErrMessage',
    setMaxVisitedStepNumber: 'setMaxVisitedStepNumber',
    setAppVersion: 'setAppVersion',
    // Participant
    setParticipant: 'setParticipant',
    // Parameters
    setUseLongAppointment: 'setUseLongAppointment',
    setUseTRMGenderChoice: 'setUseTRMGenderChoice',
    setAllowFirstAppointment: 'setAllowFirstAppointment',
    setShowAppointmentParticipantStep: 'setShowAppointmentParticipantStep',
    setIsDeleted: 'setIsDeleted',

    // Appointment
    setAppointment: 'setAppointment',
    setIsFirstAppointment: 'setIsFirstAppointment',
    setIsRdvLong: 'setIsRdvLong',
    setReasonLongAppointment: 'setReasonLongAppointment',
    setInit: 'setInit',
    setCenterWithAvailabilities: 'setCenterWithAvailabilities',
    setCenterSelected: 'setCenterSelected',
    setHasEventSelected: 'setHasEventSelected',
    SetIsBtnBackVisible: 'SetIsBtnBackVisible',
    setTrmSex: 'setTrmSex',
    setAppID: 'setAppID',
    setIsRdvModified: 'setIsRdvModified',
    setAppMobile: 'setAppMobile',
    setAppEmail: 'setAppEmail',
  };
